var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Solid_32 / star-nutral40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    d: "M13.9642 3.49095C14.7626 1.03426 18.2381 1.03427 19.0365 3.49095L21.0616 9.72279L27.6142 9.72304C30.1973 9.72314 31.2713 13.0286 29.1816 14.547L23.8805 18.3987L25.9052 24.6307C26.7033 27.0875 23.8915 29.1304 21.8017 27.6121L16.5003 23.7608L11.199 27.6121C9.10915 29.1304 6.29737 27.0875 7.09551 24.6307L9.12015 18.3987L3.81911 14.547C1.72935 13.0286 2.80336 9.72314 5.38651 9.72304L11.9391 9.7228L13.9642 3.49095Z",
    fill: "#D5D8DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star-gray.2d5885bb17ae1887dc49078f247f1bbc.svg";
export { ForwardRef as ReactComponent };